import store from '@/store/store'

export default {
	getOrgnzPstnNm: function () {
    var orgnzPstn = store.getters.orgnzPstn;
    var loginGbn = store.getters.loginGbn;  //AK(지국장, EP선생님), IS(본사직원(지금 육성지원팀만))
    // var akdmi3 = store.getters.akdmi3;
    if(loginGbn === 'AK'){
      if(orgnzPstn === 'COG01') {
        return '지국장';
      }
      // if(orgnzPstn === 'COG02') {
      //   return '지구장';
      // }
      if(orgnzPstn === 'COGA2') {
        return '에듀플래너';
      }
      if(orgnzPstn === 'COG03') {
        return '에듀플래너';
      }
      if(orgnzPstn === 'COG04') {
        return '에듀플래너';
      }
      // if(orgnzPstn === 'COG05') {
      //   return '에듀플래너';
      // }
      if(orgnzPstn === 'COG06') {
        // if(akdmi3 === '5') {
        //   return '에듀플래너';
        // }
        return '';
      }
    }else if(loginGbn === 'IS'){
        return store.getters.cntrName;
    }


    return '';
	},
  getOrgnzPstnGradeNm: function () {

    var orgnzPstn = store.getters.orgnzPstn;
    var loginGbn = store.getters.loginGbn;  //AK(지국장, EP선생님), IS(본사직원(지금 육성지원팀만))
    var akdrnk = store.getters.akdrnk;  //AK(지국장, EP선생님), IS(178(영업지원팀장), 168(영업지원매니저))

    if(loginGbn === 'AK'){
        if(orgnzPstn === 'COG01') {
          return '지국장';
          // var akdrnk = store.getters.akdrnk;
          // if(akdrnk == 5) {
          //   return '사업국장';
          // } else if(akdrnk == 6) {
          //   return '수석지국';
          // } else {
          //   return '지국장';
          // }
        }
        // if(orgnzPstn === 'COG02') {
        //   return '지구장';
        // }
        if(orgnzPstn === 'COGA2') {
          return '마스터';
        }
        if(orgnzPstn === 'COG03') {
          return '1급';
        }
        if(orgnzPstn === 'COG04') {
          return '2급';
        }
        if(orgnzPstn === 'COG05') {
          return '3급';
        }
        if(orgnzPstn === 'COG06') {
          return '파트너';
        }
    }else if(loginGbn === 'IS'){
        if(akdrnk === 178){
          return '조직육성팀장';
        }else if(akdrnk === 168){
          return '조직육성매니저';
        }else if (akdrnk === 222){
          return '업무지원매니저';
        }else {
          return '';
        }
    }
    return '';
	},
  getUserName: function () {
    return store.getters.userName;
	},
  jsonArrayStringIsEmpty: function(str) {
    if(str == '') {
      return true;
    }
    if(str == undefined) {
      return true;
    }
    try {
      var arr = JSON.parse(str);
      if(arr.length == 0) {
        return true;
      }
      return false;
    } catch(err) {
      console.log(err);
    }
    return true;
  },
}

